import { Action } from '@interstate/components/Action';
import * as dealScreenErrorSelectors from '@makemydeal/dr-dash-store/selectors/dealScreenErrorSelectors';
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';

import { PlusIcon } from '@interstate/components/Icons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { DealTabs } from '@makemydeal/dr-shared-types';
import { dealLockHooks } from '@makemydeal/dr-dash-components';
const MAX_TRADE_INS = 3;

export const AddTradeInButton = ({ isEditDisabled }: { isEditDisabled?: boolean }) => {
    const dispatch = useDispatch();
    const tradeIns = useSelector(tradeInsSelectors.getAllTradeIns);
    const tradeInErrors = useSelector((state: StateTree) =>
        dealScreenErrorSelectors.getCategoryValidationErrors(state, DealTabs.TRADE_IN, DealTabs.TRADE_IN)
    );
    const isLocked = dealLockHooks.useIsDealLocked();
    const errorIndexs = tradeInErrors
        .map((error, index) => ({ error, index }))
        .filter(({ error }) => error && Object.values(error).some((value) => value === true))
        .map(({ index }) => index);

    return (
        !isEditDisabled &&
        tradeIns.length < MAX_TRADE_INS && (
            <Action
                onClick={() => {
                    dispatch(interactionAnalyticsActionCreators.addAnotherTradeInLink());
                    dispatch(tradeInsActionCreators.addTradeIn(errorIndexs));
                }}
                data-testid="trade-card-add-trade-action"
                actionIcon={{
                    icon: <PlusIcon />,
                    start: true
                }}
                size="md"
                disabled={isLocked}
            >
                Add Another Trade-In
            </Action>
        )
    );
};
